import { SeoReviewTypeInterface } from '@components/seoPageElements/price-and-review/interface/seo.review.type.interface';
import { ReviewAggregationForTagResponse } from '@models/tag/reviewAggregationForTagResponse';

/**
 * Mock data for the price-and-review section on local builds only
 * (`env.env === 'local'`). The local API has no reviews or completed offers,
 * so the section never renders during development without this fallback.
 */
export const LOCAL_MOCK_REVIEWS: SeoReviewTypeInterface[] = [
  {
    message:
      'Hurtig og effektiv hjælp. Han kom til tiden og arbejdet var flot udført.',
    rating: 5,
    createdAt: '2026-05-28T10:15:00.000Z',
    budget: 45000,
    taskId: 1,
    taskTitle: 'Ophængning af hylder',
    firstName: 'Mette',
    profileImg: '',
  },
  {
    message:
      'Super god kommunikation hele vejen igennem. Kan varmt anbefales!',
    rating: 5,
    createdAt: '2026-05-21T14:30:00.000Z',
    budget: 120000,
    taskId: 2,
    taskTitle: 'Flytning af møbler',
    firstName: 'Jonas',
    profileImg: '',
  },
  {
    message: 'Kom samme dag og løste opgaven hurtigere end forventet.',
    rating: 5,
    createdAt: '2026-05-14T09:00:00.000Z',
    budget: 80000,
    taskId: 3,
    taskTitle: 'Samling af IKEA-skab',
    firstName: 'Camilla',
    profileImg: '',
  },
  {
    message: 'Meget grundig og pænt arbejde. Vi bruger ham helt sikkert igen.',
    rating: 5,
    createdAt: '2026-05-07T16:45:00.000Z',
    budget: 150000,
    taskId: 4,
    taskTitle: 'Maling af stue',
    firstName: 'Søren',
    profileImg: '',
  },
  {
    message: 'Venlig og professionel. Prisen var helt fair.',
    rating: 5,
    createdAt: '2026-04-30T11:20:00.000Z',
    budget: 60000,
    taskId: 5,
    taskTitle: 'Havearbejde og hækklipning',
    firstName: 'Anne',
    profileImg: '',
  },
  {
    message: 'Alt fungerede perfekt fra start til slut. Tusind tak for hjælpen!',
    rating: 5,
    createdAt: '2026-04-23T13:10:00.000Z',
    budget: 95000,
    taskId: 6,
    taskTitle: 'Opsætning af lamper',
    firstName: 'Lars',
    profileImg: '',
  },
];

export const LOCAL_MOCK_REVIEW_COUNT: ReviewAggregationForTagResponse = {
  count: {
    total: 128,
    perRating: {
      1: '1',
      2: '2',
      3: '5',
      4: '22',
      5: '98',
    },
  },
  average: 4.8,
};

export const LOCAL_MOCK_PRICES = {
  q25: 360,
  q50: 1200,
  q75: 1900,
};
